import React from 'react';
import './App.css';
import Header from "./Header";
import Sidebar from "./Sidebar";
import Footer from "./Footer";
import Dashboard from "./Dashboard";

function App() {
  return (
   
    <div className="container-scroller">
    <Header/>
    <div className="container-fluid page-body-wrapper">
     <Sidebar/>
      <div className="main-panel">
        
          {/*Page Start*/}
             <Dashboard/>
          {/*Page End*/}

      <Footer/>
      </div>
    </div>
  </div>

  );
}

export default App;
